<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <example-title src="example-1.html" title="Demo" />
    <vc-jumbotron color="red" width="auto">
      <h1 :class="['display-2']">Welcome to Vuecidity</h1>
      <h2 :class="['headline']">UI Component framework for Vue</h2>
      <vc-lorem-ipsum />
      <div>
        <vc-button :class="['ml-0']" color="yellow" :dark="false">Show Me More</vc-button>
        <vc-button :class="['ml-0']" color="green">Documentation</vc-button>
      </div>
    </vc-jumbotron>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'JumbotronPage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null
    }
  },
  mounted () {
    this.getPage()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/jumbotron.vue